import { render, staticRenderFns } from "./DetailInfo.vue?vue&type=template&id=69e1265d&scoped=true"
import script from "./DetailInfo.vue?vue&type=script&lang=js"
export * from "./DetailInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailInfo.vue?vue&type=style&index=0&id=69e1265d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e1265d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qjsz/develop/project/cc-shop-new/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e1265d')) {
      api.createRecord('69e1265d', component.options)
    } else {
      api.reload('69e1265d', component.options)
    }
    module.hot.accept("./DetailInfo.vue?vue&type=template&id=69e1265d&scoped=true", function () {
      api.rerender('69e1265d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/DetailInfo.vue"
export default component.exports